import React from 'react';

const SkeletonLoader = () => {
  return (
    <div className="animate-pulse bg-gray-300 rounded-md"></div>
  );
};

export default SkeletonLoader;
